import React from 'react';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { formatCPF } from '../../lib/utils';
import withTable, { TableContext } from '../hoc/withTable';
import Table from '../components/Table';
import { fetchPersonalDataApprovals } from '../services/personal_data_service';
import TableFilterForm from '../forms/TableFilterForm';
import {
  InputDropdownCourse,
  InputDropdownStatus,
  InputDropdownDocumentStatus,
} from '../elements';
import InputDropdownTermYear from '../elements/InputDropdownTermYear';
import InputDropdownAppropriatedBy from '../elements/InputDropdownAppropriatedBy';

// 3 = Em Análise (DocumentStatusEnum.EM_ANALISE)
const initialFilterValues = {
  document_status: 3,
};

const DocumentsPage = ({ onFilterChange }) => {
  const columns = () => [
    {
      Header: 'Protocolo',
      accessor: 'enrollment.id',
      width: 80,
      Cell: (d) => (
        <div
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
        >
          {d.value}
        </div>
      ),
    },
    {
      Header: 'Nome',
      accessor: 'real_name',
      Cell: (d) => (
        <Link
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
          to={`/academic/${get(d, 'original.enrollment.token')}`}
        >
          <p>{d.value}</p>
          {formatCPF(d)}
        </Link>
      ),
    },
    {
      Header: 'Curso',
      accessor: 'enrollment.onboarding.course.name',
      Cell: (d) => (
        <div>
          <p className="m-0">{get(d, 'value')}</p>
          <p className="m-0">
            {get(d, 'original.enrollment.onboarding.field_step')}º Ano/Período
            de promoção
          </p>
        </div>
      ),
    },
    {
      Header: 'Status do candidato',
      // Prioridade: Análise do pagamento, Aguardando pagamento/contrato, Com pendências, demais
      id: 'status_priority',
      accessor: 'enrollment.status.name',
      Cell: (d) => (
        <div
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
        >
          {d.value}
        </div>
      ),
    },
    {
      Header: 'Aprovação Acadêmica',
      accessor: 'enrollment.document_status.name',
      Cell: (d) => (
        <div
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
        >
          {d.value}
        </div>
      ),
    },
    {
      Header: 'Desconsiderado pelo comercial',
      accessor: 'enrollment.disregard_comercial',
      Cell: (d) => (
        <div
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
        >
          {d.value ? "Sim" : "Não"}
        </div>
      ),
    },
    {
      Header: 'Apropriado por',
      accessor: 'document_approval_appropriated_by',
      sortable: false,
      Cell: (d) => (
        <div
          style={{
            overflow: 'visible',
            whiteSpace: 'normal',
          }}
        >
          {d.value || '-'}
        </div>
      ),
    },
  ];

  return (
    <div className="list-base list-base-width" style={{ height: '100vh' }}>
      <TableFilterForm
        title="Aprovação - Acadêmica"
        onFilterChange={onFilterChange}
        initialValues={initialFilterValues}
      >
        <InputDropdownStatus col="6" />
        <InputDropdownCourse col="6" />
        <InputDropdownDocumentStatus col="6" />
        <InputDropdownTermYear col="6" />
        <InputDropdownAppropriatedBy col="6" />
      </TableFilterForm>
      <TableContext.Consumer>
        {(props) => <Table columns={columns()} {...props} />}
      </TableContext.Consumer>
    </div>
  );
};

// Sem coluna clicada, ordena pela prioridade do status do candidato
const fetchApprovals = (params) =>
  fetchPersonalDataApprovals({
    ...params,
    ordering: params.ordering || 'status_priority',
  });

export default withTable(fetchApprovals, {
  filters: initialFilterValues,
})(DocumentsPage);
